import { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from '../store'
import LocationUtil from '../utils/LocationUtil'
import { GeoLocation } from '../types/api.types'
import { ErrorCodes, showError } from '../utils/ErrorHandler'

export const useFetchLocation = (location?: GeoLocation) => {
  const [address, setAddress] = useState<string | undefined>()
  const dispatch: AppDispatch = useDispatch()

  useEffect(() => {
    let isMounted = true

    if (!location || !isMounted) {
      return
    }

    const fetchAddress = async () => {
      try {
        const fetchedAddress = await LocationUtil.addressForLocation(location)
        setAddress(fetchedAddress)
      } catch (error) {
        showError(ErrorCodes.REVERSE_GEOCODING_FAILED, error)
      }
    }

    fetchAddress()

    return () => {
      isMounted = false
    }
  }, [location, dispatch])

  return { address }
}
